declare global {
  interface Window {
    PSPWidget?: {
      updateToken: (token: string) => void
    }
  }
}

const WIDGET_SCRIPT_SELECTOR =
  'script[data-psp-widget-script], script[src$="/psp-widget.js"]'

export function forwardAccessTokenToPspWidget(token: string) {
  const script = document.querySelector<HTMLScriptElement>(
    WIDGET_SCRIPT_SELECTOR,
  )
  const widgetApi = window.PSPWidget

  script?.setAttribute('data-bearer-token', token)
  try {
    if (widgetApi) {
      widgetApi.updateToken(token)
    }
  } catch {
    // The script attribute remains the documented fallback delivery path.
  }
}

if (typeof window !== 'undefined') {
  try {
    sessionStorage.removeItem('psp-widget-auth-proof')
  } catch {
    // Ignore unavailable storage while removing legacy diagnostics.
  }
  Reflect.deleteProperty(window, 'PSPWidgetAuthProof')
}
